import Database from "./database";
import migrations from "./migrations";

export const DATABASES = {
    eventDb: 'eventDb',
    tileCache: 'tileCache'
}

export const datasources = {
    eventDb: migrations.events,
    tileCache: migrations.tiles
};

export const getDatabase = async (migration) => await new Database(migration);